// react-slotmachine — main entry
export { SlotMachine, default } from './SlotMachine';
export { useSlotMachineEngine } from './useSlotMachine';
export type { SlotMachineEngineOptions, SlotMachineCallbacks } from './useSlotMachine';
export type {
  SlotMachineHandle,
  SlotMachineProps,
  SlotMachineOptions,
  Direction,
  SpeedTier,
  RandomizeFn,
} from './types';

// Import CSS side-effect so bundlers pick it up
import './styles.css';

